// extracted by mini-css-extract-plugin
export default {"root":"DashboardMessagesContent_root__cr0yr","list":"DashboardMessagesContent_list__sViEl","stateText":"DashboardMessagesContent_stateText__-7lxK"};